import { Component } from '@angular/core';
import { FooterComponent } from '@coreui/angular-pro';

import packagejson from '../../../../../package.json';

@Component({
  selector: 'app-default-footer',
  templateUrl: './default-footer.component.html',
  styleUrls: ['./default-footer.component.scss'],
})
export class DefaultFooterComponent extends FooterComponent {

  public version = packagejson.version;

  constructor() {
    super();
  }
}
